var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgExclusiveRewards = function SvgExclusiveRewards(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 200,
    viewBox: "0 0 327 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 200,
    rx: 16,
    fill: "#040721"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.281 30.7513C162.451 31.0337 162.507 31.4291 162.338 31.7681L160.756 35.2705C160.586 35.6095 160.643 35.9484 160.756 36.1744H164.428L165.784 35.8355C166.123 35.779 166.518 35.8355 166.744 36.0614L166.857 36.2309H171.602L171.772 34.1972C171.828 33.8583 171.998 33.5193 172.337 33.3498L175.67 31.4291C176.461 30.9772 176.404 29.8474 175.557 29.5084L171.998 28.0397C171.659 27.9267 171.433 27.5877 171.376 27.2488L170.585 23.4639C170.416 22.56 169.286 22.2776 168.721 22.9555L166.179 25.893C165.953 26.1755 165.614 26.2884 165.219 26.2884L161.377 25.893C160.474 25.78 159.852 26.7969 160.361 27.5313L162.281 30.7513Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 53.3478L122.624 51.5401C122.172 51.3141 121.833 50.9187 121.777 50.4103L120.873 45.0436C120.647 43.8008 119.122 43.3489 118.275 44.2527L114.603 48.2071C114.264 48.6026 113.755 48.772 113.247 48.6591L107.88 47.8682C106.637 47.6987 105.733 48.998 106.355 50.1278L109.01 54.8731C109.236 55.325 109.292 55.8334 109.066 56.2854L106.637 61.1436C106.072 62.2734 107.033 63.5727 108.276 63.2903L113.586 62.2169C114.094 62.104 114.603 62.2734 114.942 62.6124L118.839 66.3973C119.743 67.3012 121.269 66.7363 121.438 65.4934L122.059 60.1268C122.116 59.6184 122.398 59.1664 122.85 58.9405L126.522 57.0198V53.3478Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.263 124.188C228.941 123.115 228.093 121.759 226.851 121.872L221.428 122.381C220.919 122.437 220.411 122.211 220.128 121.872L216.626 117.748C215.835 116.788 214.253 117.183 213.971 118.426L212.784 123.736C212.671 124.245 212.332 124.64 211.881 124.81L206.853 126.843C206.796 126.843 206.74 126.9 206.74 126.9V129.555L211.372 132.267C211.824 132.492 212.106 132.944 212.106 133.453L212.502 138.876C212.615 140.119 214.084 140.74 215.044 139.893L219.111 136.277C219.507 135.938 220.015 135.825 220.467 135.938L225.721 137.238C226.964 137.52 227.981 136.334 227.472 135.148L225.325 130.176C225.099 129.724 225.156 129.216 225.438 128.764L228.263 124.188Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.182 70.4078H140.08C138.837 70.4078 137.82 69.3909 137.82 68.1481V55.1552C137.82 53.9123 138.837 52.8955 140.08 52.8955H193.182C194.425 52.8955 195.442 53.9123 195.442 55.1552V68.1481C195.442 69.3909 194.425 70.4078 193.182 70.4078Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.294 65.606C148.478 65.606 150.249 63.8356 150.249 61.6517C150.249 59.4677 148.478 57.6973 146.294 57.6973C144.11 57.6973 142.34 59.4677 142.34 61.6517C142.34 63.8356 144.11 65.606 146.294 65.606Z",
    fill: "#FED46D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.663 65.0407H179.624C178.664 65.0407 177.929 64.3063 177.929 63.3459V59.9565C177.929 58.9961 178.664 58.2617 179.624 58.2617H188.663C189.623 58.2617 190.357 58.9961 190.357 59.9565V63.3459C190.357 64.3063 189.566 65.0407 188.663 65.0407Z",
    fill: "#FED46D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.182 133.678H140.08C138.837 133.678 137.82 132.661 137.82 131.419V118.426C137.82 117.183 138.837 116.166 140.08 116.166H193.182C194.425 116.166 195.442 117.183 195.442 118.426V131.419C195.442 132.661 194.425 133.678 193.182 133.678Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.294 128.877C148.478 128.877 150.249 127.106 150.249 124.922C150.249 122.738 148.478 120.968 146.294 120.968C144.11 120.968 142.34 122.738 142.34 124.922C142.34 127.106 144.11 128.877 146.294 128.877Z",
    fill: "#FED46D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.663 128.311H179.624C178.664 128.311 177.929 127.577 177.929 126.616V123.227C177.929 122.267 178.664 121.532 179.624 121.532H188.663C189.623 121.532 190.357 122.267 190.357 123.227V126.616C190.357 127.577 189.566 128.311 188.663 128.311Z",
    fill: "#FED46D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.182 160.228H140.08C138.837 160.228 137.82 159.211 137.82 157.968V144.975C137.82 143.733 138.837 142.716 140.08 142.716H193.182C194.425 142.716 195.442 143.733 195.442 144.975V157.968C195.442 159.211 194.425 160.228 193.182 160.228Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.294 155.426C148.478 155.426 150.249 153.656 150.249 151.472C150.249 149.288 148.478 147.518 146.294 147.518C144.11 147.518 142.34 149.288 142.34 151.472C142.34 153.656 144.11 155.426 146.294 155.426Z",
    fill: "#FED46D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.663 154.861H179.624C178.664 154.861 177.929 154.127 177.929 153.166V149.777C177.929 148.816 178.664 148.082 179.624 148.082H188.663C189.623 148.082 190.357 148.816 190.357 149.777V153.166C190.357 154.127 189.566 154.861 188.663 154.861Z",
    fill: "#FED46D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.656 106.844V45.6643C201.656 43.2352 199.678 41.3145 197.306 41.3145H181.884C181.658 43.5176 179.794 45.2688 177.534 45.2688H155.728C153.469 45.2688 151.604 43.5176 151.378 41.3145H135.956C133.527 41.3145 131.607 43.2916 131.607 45.6643V106.844",
    stroke: "#FED46D",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 111.364V169.155C131.607 171.584 133.584 173.505 135.956 173.505H197.306C199.735 173.505 201.656 171.527 201.656 169.155V111.364",
    stroke: "#FED46D",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.365 50.1281L225.325 53.5741C225.438 53.913 225.664 54.139 225.947 54.2519L229.336 55.3818C230.127 55.6642 230.297 56.6811 229.562 57.1895L226.625 59.1667C226.342 59.3362 226.173 59.6751 226.173 60.0141L226.116 63.573C226.116 64.4204 225.156 64.8723 224.478 64.3639L221.654 62.1607C221.371 61.9348 221.032 61.8783 220.75 61.9912L217.36 63.0646C216.569 63.2905 215.835 62.5562 216.117 61.7653L217.36 58.4323C217.473 58.1498 217.417 57.7544 217.247 57.5284L215.157 54.6474C214.649 53.9695 215.157 53.0091 216.004 53.0656L219.563 53.1786C219.902 53.1786 220.185 53.0656 220.411 52.7832L222.557 49.9021C223.066 49.1677 224.139 49.3372 224.365 50.1281Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.671 118.2L110.422 121.307C110.592 121.589 110.874 121.759 111.213 121.815L114.772 122.154C115.619 122.211 115.958 123.228 115.393 123.849L112.964 126.448C112.738 126.674 112.625 127.013 112.738 127.352L113.529 130.854C113.699 131.645 112.908 132.323 112.117 131.984L108.897 130.515C108.615 130.402 108.276 130.402 107.993 130.572L104.943 132.379C104.208 132.831 103.361 132.21 103.417 131.419L103.813 127.86C103.869 127.521 103.7 127.182 103.474 127.013L100.762 124.64C100.141 124.075 100.423 123.058 101.214 122.889L104.717 122.211C105.056 122.154 105.338 121.928 105.451 121.646L106.863 118.369C107.202 117.522 108.276 117.466 108.671 118.2Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8307 28.6601L96.6384 30.2419C96.8079 30.4113 97.0338 30.4678 97.2598 30.4113L99.576 29.8464C100.141 29.7334 100.593 30.2419 100.367 30.7503L99.4065 32.9534C99.2935 33.1794 99.35 33.4054 99.463 33.5749L100.706 35.6085C100.988 36.0605 100.649 36.6819 100.084 36.6254L97.7117 36.3994C97.4858 36.3994 97.2598 36.4559 97.1468 36.6254L95.6216 38.4331C95.2826 38.885 94.6047 38.7156 94.4353 38.1506L93.9268 35.8345C93.8703 35.6085 93.7009 35.4391 93.5314 35.3826L91.3282 34.4787C90.8198 34.2527 90.7633 33.5749 91.2153 33.2924L93.2489 32.0496C93.4184 31.9366 93.5879 31.7106 93.5879 31.5412L93.7574 29.1685C93.7574 28.6036 94.4353 28.3212 94.8307 28.6601Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.361 109.387C104.765 109.387 105.903 108.249 105.903 106.845C105.903 105.441 104.765 104.303 103.361 104.303C101.957 104.303 100.819 105.441 100.819 106.845C100.819 108.249 101.957 109.387 103.361 109.387Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.473 38.7717C218.877 38.7717 220.015 37.6336 220.015 36.2296C220.015 34.8256 218.877 33.6875 217.473 33.6875C216.069 33.6875 214.931 34.8256 214.931 36.2296C214.931 37.6336 216.069 38.7717 217.473 38.7717Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.431 24.6496C135.835 24.6496 136.973 23.5115 136.973 22.1075C136.973 20.7036 135.835 19.5654 134.431 19.5654C133.027 19.5654 131.889 20.7036 131.889 22.1075C131.889 23.5115 133.027 24.6496 134.431 24.6496Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.178 31.4291C119.646 31.4291 120.026 31.0497 120.026 30.5817C120.026 30.1138 119.646 29.7344 119.178 29.7344C118.71 29.7344 118.331 30.1138 118.331 30.5817C118.331 31.0497 118.71 31.4291 119.178 31.4291Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.354 115.036C116.822 115.036 117.201 114.656 117.201 114.188C117.201 113.72 116.822 113.341 116.354 113.341C115.886 113.341 115.506 113.72 115.506 114.188C115.506 114.656 115.886 115.036 116.354 115.036Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M222.557 113.906C223.025 113.906 223.405 113.526 223.405 113.058C223.405 112.59 223.025 112.211 222.557 112.211C222.089 112.211 221.71 112.59 221.71 113.058C221.71 113.526 222.089 113.906 222.557 113.906Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.985 49.5063C235.453 49.5063 235.833 49.1269 235.833 48.6589C235.833 48.1909 235.453 47.8115 234.985 47.8115C234.517 47.8115 234.138 48.1909 234.138 48.6589C234.138 49.1269 234.517 49.5063 234.985 49.5063Z",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.903 74.9268V80.5759",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.728 77.752H103.078",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M228.489 98.0879V103.737",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.313 100.913H225.664",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M201.373 19.5654V25.2146",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M204.198 22.3906H198.549",
    stroke: "#37394C",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.484 178.871H215.778",
    stroke: "#FED46D",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M206.74 106.845V44.1392C206.74 39.7894 203.181 36.2305 198.831 36.2305H134.431C130.081 36.2305 126.522 39.7894 126.522 44.1392V106.845",
    stroke: "#FED46D",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 111.364V170.68C126.522 175.03 130.081 178.589 134.431 178.589H198.831C203.181 178.589 206.74 175.03 206.74 170.68V111.364",
    stroke: "#FED46D",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M209.903 107.128H123.359C122.116 107.128 121.099 106.111 121.099 104.868V81.7069C121.099 80.4641 122.116 79.4473 123.359 79.4473H209.903C211.146 79.4473 212.163 80.4641 212.163 81.7069V104.868C212.163 106.111 211.146 107.128 209.903 107.128Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146.577 90.3496H159.513",
    stroke: "#05081F",
    strokeWidth: 3.38947,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.577 96.2246H166.066",
    stroke: "#9B9CA5",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M134.713 100.914C138.925 100.914 142.34 97.4993 142.34 93.2874C142.34 89.0756 138.925 85.6611 134.713 85.6611C130.502 85.6611 127.087 89.0756 127.087 93.2874C127.087 97.4993 130.502 100.914 134.713 100.914Z",
    stroke: "#05081F",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.714 97.5245C137.053 97.5245 138.95 95.6276 138.95 93.2876C138.95 90.9477 137.053 89.0508 134.714 89.0508C132.374 89.0508 130.477 90.9477 130.477 93.2876C130.477 95.6276 132.374 97.5245 134.714 97.5245Z",
    fill: "#FED46D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M192.617 97.2417H173.975C173.071 97.2417 172.28 96.4508 172.28 95.547V89.8979C172.28 88.9375 173.071 88.2031 173.975 88.2031H192.617C193.521 88.2031 194.312 88.9375 194.312 89.8979V95.547C194.312 96.4508 193.521 97.2417 192.617 97.2417Z",
    fill: "#FED46D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M201.373 89.3896L204.932 93.0051L201.373 96.6205",
    stroke: "#696B79",
    strokeWidth: 1.69474,
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgExclusiveRewards);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclusive-rewards.06d51d577f000815fdbe7379e7205301.svg";